import { basic, vehicleInfo } from 'api';
import {
  UI_SET_LOADER,
  UI_SET_MENU,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  GET_MARKDOWN_FILE,
  UI_GET_MASTER_DATA,
  UI_UPDATE_MASTER_DATA,
  UI_GET_DOCUMENTATION_MASTERDATA,
  UI_GET_REMPLACEMENT_VEHICLE_MASTERDATA
} from 'store/actions/ui';
import { mapArraryMasterDataReplaceVehicle } from 'helpers/object';

export default {
  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [UI_SET_MENU]: ({ commit }, opening) => {
    commit(UI_SET_MENU, opening);
  },

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.data(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),
  [UI_GET_MASTER_DATA]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasMasterData) {
        vehicleInfo.getMasterData().then(
          resp => {
            commit(UI_UPDATE_MASTER_DATA, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),
  [UI_GET_DOCUMENTATION_MASTERDATA]: ({ commit }) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .documentationMasterdata()
        .then(resp => {
          const { countries, fittings } = resp.data;
          const data = {};
          data.countries = mapArraryMasterDataReplaceVehicle(countries);
          data.fittings = mapArraryMasterDataReplaceVehicle(fittings);
          commit(SET_UI_PROPERTY, { field: 'documentation', value: data });
          resolve();
        })
        .catch(err => {
          reject(err.response);
        });
    }),
  [UI_GET_REMPLACEMENT_VEHICLE_MASTERDATA]: ({ commit }) =>
    new Promise((resolve, reject) => {
      vehicleInfo
        .replacementvehicleMasterdata()
        .then(resp => {
          const { inmobilizations, locations, repairs } = resp.data;
          const data = {};
          data.inmobilizations = mapArraryMasterDataReplaceVehicle(inmobilizations);
          data.locations = mapArraryMasterDataReplaceVehicle(locations);
          data.repairs = mapArraryMasterDataReplaceVehicle(repairs);
          commit(SET_UI_PROPERTY, { field: 'replaceVehicle', value: data });
          resolve();
        })
        .catch(err => {
          reject(err.response);
        });
    })
};
